import {
    URL_CITRUSGPT_ABRIR_CHAT,
    URL_CITRUSGPT_BUSCAR_CONVERSACIONES,
    URL_CITRUSGPT_INICIAR_CHAT,
    URL_CITRUSGPT_NUEVA_CONVERSACION,
    URL_CITRUSGPT_PREGUNTAR
} from "../Utils/constant.js";

import { buscar } from "../../../Commons/Scripts/Utils/Buscar";

/** La conversación activa con su historial, los chats recientes y los permisos. */
export const iniciarChat = () => buscar(URL_CITRUSGPT_INICIAR_CHAT, {});

/** Carga un chat anterior del listado de recientes. */
export const abrirChat = (id) => buscar(URL_CITRUSGPT_ABRIR_CHAT, { id });

/** Cierra las conversaciones abiertas y arranca una nueva. */
export const nuevaConversacion = () => buscar(URL_CITRUSGPT_NUEVA_CONVERSACION, {});

/** Una página del historial, de la conversación más reciente a la más vieja. */
export const buscarConversaciones = (pagina) =>
    buscar(URL_CITRUSGPT_BUSCAR_CONVERSACIONES, { pagina: pagina || 0 });

/** Manda una pregunta y devuelve el historial ya actualizado. */
export const preguntar = (conversacionId, pregunta) =>
    buscar(URL_CITRUSGPT_PREGUNTAR, { conversacionId, pregunta });
